import { render } from "./PlacebidModal.vue?vue&type=template&id=b4eed380"
import script from "./PlacebidModal.vue?vue&type=script&lang=js"
export * from "./PlacebidModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\TEMPLATES\\nuron-nft-marketplace-vue-js-template\\nuron-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__